export const BackIcon = () => (
  <svg width="14" height="10" xmlns="http://www.w3.org/2000/svg">
    <g
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 1L1 5l4 4M1 5h12" />
    </g>
  </svg>
);
